<template>
    <component :is="linksComponent" v-bind="$attrs" />
</template>

<script setup>
import { resolveClientComponent } from '@/composables/useEdverumClient.js';
import CorporateTopbarLinks from '@/layouts/navigation/CorporateTopbarLinks.vue';
import StanbridgeTopbarLinks from '@/layouts/navigation/StanbridgeTopbarLinks.vue';

defineOptions({
    name: 'TopbarLinks',
    inheritAttrs: false,
});

const linksComponent = resolveClientComponent({
    stanbridge: StanbridgeTopbarLinks,
    corporate: CorporateTopbarLinks,
});
</script>
